export const enum OrganizationSubscriptionStatus {
  Active = 'active',
  PastDue = 'past_due',
  Canceled = 'canceled',
  Unpaid = 'unpaid',
  Trialing = 'trialing',
  TrialExpired = 'trial_expired',
}

export interface OrganizationSubscription {
  id: number
  organization_id: number
  subscription_id: string
  subscription_kind: string
  subscription_status: OrganizationSubscriptionStatus
  product_identifier?: string
  seat_count: number
  created_at: Date
  updated_at: Date
  trial_end?: string
  sale_rep_id?: number | string
  stripe_customer_id?: string
  subscription_status_override?: string
  billing_interval?: string
  recurring_amount?: string
  collection_resumes_at?: string
  next_billing_date?: string
  is_paused_subscription?: boolean
  appstle_subscription_id?: string
  is_linq_blue?: boolean
  customer_product_type?: string
}
